import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'
console.log(Layout,'Layout')

// 公共路由
export const constantRoutes = [
  // {
  //   path: '/',
  //   component: () => import('@/views/index'),
  //   hidden: true
  // }, 

  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'index',
    children: [
      {
        path: '/',
        component: () => import('@/views/index'),
        name: 'index',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },{
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index'),
        name: 'index',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },{
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'aboutus',
    children: [
      {
        path: '/aboutus',
        component: () => import('@/views/aboutus'),
        name: 'aboutus',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },{
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'contact',
    children: [
      {
        path: '/contact',
        component: () => import('@/views/contact'),
        name: 'contact',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },{
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'scheme',
    children: [
      {
        path: '/scheme',
        component: () => import('@/views/scheme'),
        name: 'scheme',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },{
    path: '',
    component: Layout,
    hidden: true,
    redirect: 'news',
    children: [
      {
        path: '/news',
        component: () => import('@/views/news'),
        name: 'news',
        meta: { title: '', icon: '',affix: true  }
      }
    ]
  },

  
]


// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
let routerReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
